import { isSummaryRelevantFieldType } from '@shared/utils/isSummaryRelevantFieldType';
import { resultValueNotAppliable, getUnModifiedFields } from '../lib/constants/unmodifiedFields';
import { PageTypes } from '@shared/types';
import { addCommas } from '@shared/lib/utils/addCommas';
import { formatShippingDate } from './formatShippingDate';
import { summaryTableDocumentTypes } from '@entities/project/document/lib/constants/documentTypes';
export function getFieldValue(row, field, index, dateFormat, t) {
    if (isSummaryRelevantFieldType(row.type)) {
        if (getUnModifiedFields(row.type).includes(field.property)) {
            return resultValueNotAppliable;
        }
    }
    switch (field.property) {
        case 'index': {
            return index + 1;
        }
        case 'filename': {
            return row.documentName || null;
        }
        case 'type': {
            return t(summaryTableDocumentTypes[row[field.property]]);
        }
        case 'weight':
            return row[field.property] !== null ? addCommas(row[field.property]) + ' kg' : '';
        case 'shippingDate':
            return row[field.property] !== null
                ? formatShippingDate(row[field.property], dateFormat)
                : '';
        case 'pageNumber':
        case 'companyName':
        case 'certificateNumber':
        case 'materialType':
        case 'materialName':
        case 'diameter':
        case 'id':
        case 'quantities': {
            return row[field.property];
        }
        case 'location':
        case 'customQuantities':
        case 'totalQuantities':
            if (row.type === PageTypes.certificate)
                return resultValueNotAppliable;
            return row[field.property];
        case 'customLength':
        case 'length': {
            return row[field.property] !== null ? Number(row[field.property]).toFixed(2) + ' m' : '';
        }
        default: {
            return null;
        }
    }
}
